import { createAction, createAsyncAction } from 'typesafe-actions';

import type { Feedback } from '@portal/api-models';

import { FeedbackActionType } from './actionTypes';
import type { FeedbackForm } from './types';

export const feedbackCreateRequestAction = createAsyncAction(
  FeedbackActionType.CREATE_REQUEST_CLIENT,
  FeedbackActionType.CREATE_SUCCESS_CLIENT,
  FeedbackActionType.CREATE_FAILURE_CLIENT
)<FeedbackForm, Feedback, Error>();

export const toggleFeedbackDrawer = createAction(
  FeedbackActionType.TOGGLE_FEEDBACK_DRAWER
)<undefined>();
